import { render, staticRenderFns } from "./MerchantGroup.vue?vue&type=template&id=67f719bc&scoped=true"
import script from "./MerchantGroup.vue?vue&type=script&lang=js"
export * from "./MerchantGroup.vue?vue&type=script&lang=js"
import style0 from "./MerchantGroup.vue?vue&type=style&index=0&id=67f719bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f719bc",
  null
  
)

export default component.exports